import { Tooltip, useTheme } from "@mui/material";
import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { ReactElement } from "react";
import { IconButton } from "../ui/icons";

const IconInfo = ({ text }: { text: ReactElement }) => {
  const theme = useTheme();
  return (
    <Tooltip id="tooltip" title={text} placement="right" arrow>
      <IconButton noPadding={true} data-cy="tooltip-container-icon-info">
        <InfoIcon color={theme.palette.text40.main} size="16px" />
      </IconButton>
    </Tooltip>
  );
};

export default IconInfo;
